import { B as C } from "./enums-PybBMp8G.js";
/**
 * @preserve
 * Licenses of bundled dependencies can be found in dependencies-licenses.txt
 */
/*! B2XCORE - Profile Library version: 2.104.0 */
const E = "B2XCORE_PROFILE", s = `swsp:${E}`, O = "SET_STATE", N = {
  BOOTSTRAP: "Bootstrap",
  PAL: "Pal",
  CONNECTION: "PL Connection",
  UCMC_CONNECTION: "UCMC Connection",
  LEGACY_CONNECTION: "Legacy Connection",
  PROFILE: "Profile",
  ONE_HEADER: "One Header"
}, n = "CSCS_USER_CONTEXT_MANAGER", o = "SET_STATE", _ = {
  id: null,
  // When there is an error in PL, activeProfile.id will be null
  displayName: null,
  customerGroupId: null,
  market: null,
  customerType: null,
  businessType: C.B2C
};
export {
  O as A,
  _ as E,
  N as L,
  E as P,
  n as U,
  s as a,
  o as b
};
